module.exports = __webpack_public_path__ + "img/product_106.08eb653.webp";